import React from "react";

const AssessmentQuestion = ({ question, register, watch, errors, disabled }) => {
    const isYesSelected = watch(`answer-${question.questionId}`) === true;

    return (
        <div key={question.questionId} className="card mb-3">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="card-title mb-0">
                        #{question.questionId}: {question.questionText}
                    </h5>
                    {!question.commentOnly && (
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`answer-${question.questionId}`}
                                defaultChecked={question.answer?.answerValue ?? false}
                                {...register(`answer-${question.questionId}`)}
                                disabled={disabled}
                            />
                            <label className="form-check-label" htmlFor={`answer-${question.questionId}`}>
                                No / Yes
                            </label>
                        </div>
                    )}
                </div>

                {question.commentOnly && (
                    <div className="mb-3">
                        <label htmlFor={`comment-${question.questionId}`} className="form-label">
                            Comment *
                        </label>
                        <textarea
                            className="form-control"
                            id={`comment-${question.questionId}`}
                            {...register(`comment-${question.questionId}`, {
                                required: "Comment is required for this question."
                            })}
                            rows={3}
                            disabled={disabled}
                        />
                        {errors[`comment-${question.questionId}`] && (
                            <small className="text-danger">
                                {errors[`comment-${question.questionId}`].message}
                            </small>
                        )}
                    </div>
                )}

                {(question.quantityThreshold !== null || question.amountThreshold !== null) && (
                    <div className="row mb-3">
                        {question.quantityThreshold !== null && (
                            <div className="col-md-6">
                                <label htmlFor={`quantity-${question.questionId}`} className="form-label">Quantity</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id={`quantity-${question.questionId}`}
                                    defaultValue={question.answer?.quantity ?? ""}
                                    {...register(`quantity-${question.questionId}`, {
                                        required: isYesSelected ? "Quantity is required when Yes is selected." : false
                                    })}
                                    min="0"
                                    disabled={disabled}
                                />
                                {errors[`quantity-${question.questionId}`] && (
                                    <small className="text-danger">
                                        {errors[`quantity-${question.questionId}`].message}
                                    </small>
                                )}
                            </div>
                        )}
                        {question.amountThreshold !== null && (
                            <div className="col-md-6">
                                <label htmlFor={`amount-${question.questionId}`} className="form-label">Combined Amount</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id={`amount-${question.questionId}`}
                                    defaultValue={question.answer?.amount ?? ""}
                                    {...register(`amount-${question.questionId}`, {
                                        required: isYesSelected ? "Amount is required when Yes is selected." : false
                                    })}
                                    step="0.01"
                                    min="0"
                                    disabled={disabled}
                                />
                                {errors[`amount-${question.questionId}`] && (
                                    <small className="text-danger">
                                        {errors[`amount-${question.questionId}`].message}
                                    </small>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AssessmentQuestion;
